import { render } from "./LoginRegister.vue?vue&type=template&id=367c7909&scoped=true"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"

import "./LoginRegister.vue?vue&type=style&index=0&id=367c7909&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367c7909"]])

export default __exports__